import React from "react";

const sectors = [
  {
    id: 1,
    name: "ADR & Dangerous Goods",
    description:
      "We understand that safety is key when it comes to delivering ADR & dangerous goods. Every consignment of dangerous goods is handled with extra care and attention.",
    icon: "🚛",
    link: "#",
  },
  {
    id: 2,
    name: "Construction",
    description:
      "No matter whether you’ve got a quarter pallet or several full ones that need transporting, our team will work with you to provide the best solution to get your items on-site, warehouse, or storage facility.",
    icon: "🏗️",
    link: "#",
  },
  {
    id: 3,
    name: "Furniture & Fabrics",
    description:
      "We have experts in furniture & fabric logistics. With a dedicated in-house team that offers a 2-man white glove service for furniture, rugs, and fabrics of any size. Take the stress away.",
    icon: "🛋️",
    link: "#",
  },
  {
    id: 4,
    name: "Art & Antiques",
    description:
      "Whether it’s an antique piece of furniture or a collector’s item painting, we have various solutions. Not only will it be handled professionally, but it can be delivered with our white glove service.",
    icon: "🎨",
    link: "#",
  },
  {
    id: 5,
    name: "Engineering",
    description:
      "Need a part delivered same day? We cover all engineering sectors from biomedical to civil engineering. No matter how big or small the parts are, we have a vehicle to help facilitate the delivery.",
    icon: "⚙️",
    link: "#",
  },
  {
    id: 6,
    name: "Jewellery",
    description:
      "You may feel hesitant about sending jewellery and high-value goods, since they require extra care and attention. Choosing the right courier will ensure your goods are delivered safely.",
    icon: "💎",
    link: "#",
  },
  {
    id: 7,
    name: "Aviation (AOG)",
    description:
      "As flights are scheduled at specific times in tight windows, the courier you select needs to be on time and efficient. We pride ourselves on our efficiency and wide range of Aviation/AOG courier services.",
    icon: "✈️",
    link: "#",
  },
  {
    id: 8,
    name: "Exhibition & Events",
    description:
      "Exhibitions and events are all about preparation. If you fail to prepare properly, the chances are your event isn’t going to be a success. One of the biggest parts of preparation is in the setup.",
    icon: "🎪",
    link: "#",
  },
  {
    id: 9,
    name: "Legal",
    description:
      "Sceptical about posting important papers and legal documents? Need the documents to get there without any interruption? An efficient legal document courier can help.",
    icon: "📜",
    link: "#",
  },
  {
    id: 10,
    name: "Oil & Gas",
    description:
      "We understand that safety is key when it comes to delivering Oil & Gas cargo. Our drivers are trained to handle all hazardous oil & gas needs.",
    icon: "🛢️",
    link: "#",
  },
  {
    id: 11,
    name: "Pharmaceutical",
    description:
      "The transportation of medicine is crucial to the health and wellbeing of the population. Our pharmaceutical courier services are flexible to meet the needs of the medical industry.",
    icon: "💊",
    link: "#",
  },
  {
    id: 12,
    name: "Photography & Production",
    description:
      "From engineering to the music industry, production equipment is necessary for many businesses. We have a team just for this.",
    icon: "📷",
    link: "#",
  },
];

const SectorsGrid = () => {
  return (
    <div>
       <section id="contact" className="py-40 bg-gray-900 text-white text-center">
        <h2 className="text-3xl md:text-6xl font-bold mb-4">Sectors</h2>
        {/* <p className="text-lg mb-8">Fast, reliable, and efficient delivery services tailored to your needs.</p>
        <a href="tel:+44-123-456-7890" className="inline-block px-8 py-3 bg-orange-600 text-white rounded-lg hover:bg-orange-800 transition duration-300">
          Call Us Now
        </a> */}
      </section>
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Title */}
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-8">
          Sectors We Work With
        </h2>

        {/* Grid Layout */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {sectors.map((sector) => (
            <div
              key={sector.id}
              className="bg-white shadow-md rounded-lg p-6 hover:shadow-lg transition-all duration-300"
            >
              {/* Icon */}
              <div className="text-4xl text-gray-700 mb-4">{sector.icon}</div>

              {/* Sector Name */}
              <h3 className="text-xl font-semibold text-gray-800 mb-2">
                {sector.name}
              </h3>

              {/* Description */}
              <p className="text-gray-600 mb-4">{sector.description}</p>

              {/* Learn More Link */}
              <a
                href={sector.link}
                className="text-blue-500 hover:underline font-medium"
              >
                Learn More
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
    </div>
  );
};

export default SectorsGrid;
